import React from "react";
import AnnouncementBar from "../../components/AnnouncementBar/AnnouncementBar";
import ProfileForm from "../../components/UserAccountDetails/ProfileForm";

export const EditProfile = () => {
  return (
    <>
      <AnnouncementBar />
      <ProfileForm />
    </>
  );
};
export default EditProfile;
